var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "quicktrial-final__wrapper" }, [
    _c(
      "header",
      { staticClass: "onboarding-quicktrial__informations-header" },
      [
        _c(
          "icon-svg",
          {
            staticClass: "onboarding-quicktrial__informations-header-logo",
            attrs: {
              iconName: "sellsy",
              width: _vm.isDesktop ? 118 : 168,
              height: _vm.isDesktop ? 28 : 40,
              viewBox: _vm.isDesktop ? "0 0 118 28" : "0 0 168 40"
            }
          },
          [_c("icon-sellsy-text")],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("article", { staticClass: "quicktrial-final__inner" }, [
      _c("div", { ref: "lottie" }),
      _vm._v(" "),
      _c("p", {
        class: [
          "quicktrial-final__title",
          _vm.isDesktop
            ? "typographies-display-brand-medium"
            : "typographies-display-small"
        ],
        domProps: {
          innerHTML: _vm._s(
            _vm.$t.__(
              "pages.onboarding.trial.OnboardingQuickTrialFinal.wait_while_account_creating",
              { br: "<br>" }
            )
          )
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }